import { Drawer, Flex, Typography } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer).attrs(({ theme }) => ({
  placement: 'bottom',
  closable: false,
  size: '154px',
  style: {
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
  },
  styles: {
    header: {
      height: 58,
      fontSize: 15,
      textAlign: 'center',
      color: theme.colorTextTertiary,
      fontWeight: 400,
    },
    body: {
      padding: '0',
    },
  },
}))``;

export const DrawerContent = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
  flex: 1,
  vertical: true,
})``;

export const DrawerElement = styled(Flex)`
  width: 100%;
  padding: 12px;
  margin: auto;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.colorBorder};
`;

export const DrawerElementLabel = styled(Typography.Text)`
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  color: ${({ theme }) => theme.colorPrimary};
  width: 100%;
`;
